const getCookie = () => {
  const cookies = document.cookie.split('; ');
  const cookie = cookies.find((c) => c.startsWith(`${'BMI-admin-session'}=`));
  if (cookie) {
    return cookie.split('=')[1];
  } else {
    return false;
  }
};

const handleSessionExpire = () => {
  //remove cookie if not found
  const isSecure = window.location.protocol === 'https:';
  document.cookie = `BMI-admin-session=; path=/; max-age=0; SameSite=Strict${isSecure ? '; secure' : ''}`;
  localStorage.removeItem('BMI-admin-is-logged');
  localStorage.setItem(
    'BMI-admin-message',
    'session expired, please login back.'
  );
  window.location.href = '/';
  return;
};

export { getCookie, handleSessionExpire };
